/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driver_Order_Pickup_QrInputs */

const vi_driver_order_pickup_qr = /** @type {(inputs: Driver_Order_Pickup_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR nhận đơn`)
};

/**

* @param {Driver_Order_Pickup_QrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_order_pickup_qr = /** @type {((inputs?: Driver_Order_Pickup_QrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_Order_Pickup_QrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_order_pickup_qr(inputs)
});